<form [formGroup]="form" class="row">
  <div class="col-12 mb-3">
    <h2>DATOS DEL RECLAMO</h2>
  </div>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input placeholder="Nombre del Cliente" formControlName="nombre_cliente" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Nombre del Cliente</mat-label>
    <input formControlName="nombre_cliente" matInput />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input ciRif placeholder="CI / RIF / Pasaporte" formControlName="ci_rif_pasaporte" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>CI / RIF / Pasaporte</mat-label>
    <input
      ciRif
      placeholder="CI / RIF / Pasaporte"
      formControlName="ci_rif_pasaporte"
      matInput
    />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input min="20" max="20" placeholder="Nº de Cuenta" formControlName="numero_cuenta" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Nº de Cuenta</mat-label>
    <input
      min="20"
      max="20"
      placeholder="Nº de Cuenta"
      formControlName="numero_cuenta"
      matInput
    />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input type="number" placeholder="Nº de Sake" formControlName="numero_sake" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Nº de Sake</mat-label>
    <input
      type="number"
      placeholder="Nº de Sake"
      formControlName="numero_sake"
      matInput
    />
  </mat-form-field>

  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input placeholder="Fecha de Inicio" onfocus="(this.type='date')" formControlName="fecha_inicio" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Fecha de Inicio</mat-label>
    <input
      placeholder="Fecha de Inicio"
      onfocus="(this.type='date')"
      formControlName="fecha_inicio"
      matInput
    />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input placeholder="Fecha de Fin" onfocus="(this.type='date')" formControlName="fecha_fin" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Fecha de Fin</mat-label>
    <input
      placeholder="Fecha de Fin"
      onfocus="(this.type='date')"
      formControlName="fecha_fin"
      matInput
    />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input placeholder="Total Monto Reclamado" formControlName="total_monto_reclamado" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Total Monto Reclamado</mat-label>
    <input
      placeholder="Total Monto Reclamado"
      formControlName="total_monto_reclamado"
      matInput
    />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input placeholder="Total Nº TX Reclamadas" formControlName="total_numero_tx_reclamadas" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Total Nº TX Reclamadas</mat-label>
    <input
      placeholder="Total Nº TX Reclamadas"
      formControlName="total_numero_tx_reclamadas"
      matInput
    />
  </mat-form-field>

  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input placeholder="Seleccione Medio Magnetico" formControlName="medio_magenetico" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Seleccione Medio Magnetico</mat-label>
    <input
      placeholder="Seleccione Medio Magnetico"
      formControlName="medio_magenetico"
      matInput
    />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input type="number" placeholder="Nº Medio" formControlName="numero_medio" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Nº Medio</mat-label>
    <input
      type="number"
      placeholder="Nº Medio"
      formControlName="numero_medio"
      matInput
    />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input onfocus="(this.type='date')" placeholder="Fecha último uso" formControlName="fecha_ultimo_uso" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Fecha último uso</mat-label>
    <input
      onfocus="(this.type='date')"
      placeholder="Fecha último uso"
      formControlName="fecha_ultimo_uso"
      matInput
    />
  </mat-form-field>
  <!-- <div class="style-input-default column-complete col-3 mb-3">
    <input onfocus="(this.type='date')" placeholder="Fecha de Bloqueo" formControlName="fecha_bloqueo" />
  </div> -->
  <mat-form-field appearance="outline" class="col-4">
    <mat-label>Fecha de Bloqueo</mat-label>
    <input
      onfocus="(this.type='date')"
      placeholder="Fecha de Bloqueo"
      formControlName="fecha_bloqueo"
      matInput
    />
  </mat-form-field>
  <h2>DISTRIBUCIÓN DEL MONTO RECLAMADO</h2>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Monto</th>
        <th scope="col">ATM</th>
        <th scope="col">POS</th>
        <th scope="col">ADELANTO TAQUILLA</th>
        <th scope="col">Credcompra</th>
        <th scope="col">Otras Operaciones</th>
        <th scope="col">Comisiones</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <th scope="row">Monto Reclamado</th>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_reclamado_atm"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_reclamado_pos"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_reclamado_adelanto_taquilla"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_reclamado_credcompra"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_reclamado_otras_operaciones"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_reclamado_comisiones"
          />
        </td>
      </tr>
      <tr>
        <th scope="row">Monto Salvado</th>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_salvado_atm"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_salvado_pos"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_salvado_adelanto_taquilla"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_salvado_credcompra"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_salvado_otras_operaciones"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_salvado_otras_operaciones"
          />
        </td>
      </tr>
      <tr>
        <th scope="row">Monto Sujeto a Decisión</th>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_sujeto_desicion_atm"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_sujeto_desicion_pos"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_sujeto_desicion_adelanto_taquilla"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_sujeto_desicion_credcompra"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_sujeto_desicion_otras_operaciones"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_sujeto_desicion_otras_operaciones"
          />
        </td>
      </tr>
      <tr>
        <th scope="row">Número de TX</th>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_numero_tx_atm"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_numero_tx_pos"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_numero_tx_adelanto_taquilla"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_numero_tx_credcompra"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_numero_tx_otras_operaciones"
          />
        </td>
        <td>
          <input
            class="input-peque"
            Currency
            formControlName="monto_numero_tx_otras_operaciones"
          />
        </td>
      </tr>
    </tbody>
  </table>
  <h2>DESCRIPCIÓN DE LOS HECHOS</h2>
  <div class="style-input-default column-complete col-12 mb-3">
    <textarea
      rows="6"
      placeholder=""
      formControlName="descripcion_hechos"
    ></textarea>
  </div>
  <div class="row" style="width: 100%">
    <div class="col-4">
      <p class="text-center radio">Alerta Monitoreo:</p>
      <mat-radio-group
        class="checleft"
        formControlName="alerta_monitoreo"
        aria-label="Seleccione una opción"
      >
        <mat-radio-button class="marginRight" [value]="true"
          >Si</mat-radio-button
        >
        <mat-radio-button class="marginLeft" [value]="false"
          >No</mat-radio-button
        >
      </mat-radio-group>
    </div>
    <div class="col-4">
      <p class="text-center radio">Gestión De Alerta:</p>
      <mat-radio-group
        class="checleft"
        formControlName="gestion_alerta"
        aria-label="Seleccione una opción"
      >
        <mat-radio-button class="marginRight" [value]="true"
          >Si</mat-radio-button
        >
        <mat-radio-button class="marginLeft" [value]="false"
          >No</mat-radio-button
        >
      </mat-radio-group>
    </div>
    <div class="col-4 text-center">
      <p class="text-center radio">Notificación SMS:</p>
      <mat-radio-group
        class="checleft"
        formControlName="notificacion_sms"
        aria-label="Seleccione una opción"
      >
        <mat-radio-button class="marginRight" [value]="true"
          >Si</mat-radio-button
        >
        <mat-radio-button class="marginLeft" [value]="false"
          >No</mat-radio-button
        >
      </mat-radio-group>
    </div>
  </div>
</form>
